import { PayloadAction, createSlice } from "@reduxjs/toolkit"

export type AuthStateType = {
  token?: string
  user?: any
}

const initialState: AuthStateType = {
  token: "",
  user: null,
}

const authSlice = createSlice({
  name: "auth",
  initialState: initialState,
  reducers: {
    setAuth: (state, action: PayloadAction<any>): AuthStateType => ({
      ...action.payload,
    }),
    setUser: (state, action: PayloadAction<any>): AuthStateType => ({
      ...state,
      user: action.payload,
    }),
    setToken: (state, action: PayloadAction<any>): AuthStateType => ({
      ...state,
      token: action.payload,
    }),
    logOut: () => initialState,
  },
})

export const { setAuth, setUser, setToken, logOut } = authSlice.actions
export default authSlice.reducer
